module.exports = __webpack_public_path__ + "static/img/200144.f80849e3.png";